const API = {
  url: 'https://optout-req.tadoo.biz/execute',
  getClientInfoUrl : 'https://optout-req.tadoo.biz/info'
};

export default API;
